import { SocialIcon } from '@ori-ui/components';
import type { StaticApplicationsFooterBffSocialMediaLinkDto } from '@ori/static-api-client-react';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React from 'react';

import { SocialMediaIcons } from '../../../models';
import { SOCIAL_MEDIA_ICON } from '../constants';

export type SocialMediaIconProps = StaticApplicationsFooterBffSocialMediaLinkDto;

export const SocialMediaIcon: FC<SocialMediaIconProps> = ({ type, title, url }) => {
  const { getTestId } = useTestId();
  const kind = SocialMediaIcons[type];

  return (
    <SocialIcon
      kind={kind}
      size="medium"
      component="a"
      data-testid={getTestId(SOCIAL_MEDIA_ICON)}
      aria-label={title ?? ''}
      href={url ?? ''}
      title={title ?? ''}
    />
  );
};
